const volcanes = {
  payingByMessage: 'Pagando vía ',
  safePaymentPage: 'Página de pagos segura',
  finishYourPaymentMessage: 'Para finalizar tu compra, realiza tu pago aquí :)',
  emptyCardSecurityCode: 'Ingresa tu código CVV dinámico de tu app bancaria.',
  inputCustomerName: 'Nombre y Apellido',
  inputCustomerEmail: 'Correo Electrónico',
  inputCustomerPhoneNumber: 'Teléfono',
  inputCustumerPhoneNumberOptional: '(opcional)',
  invalidSecurityCode: 'El CVV informado es inválido.',
  invalidCvv: 'El CVV informado es inválido.',
  fieldCardSecurityCode: 'Código de Seguridad (CVV)',
  fieldCardHolderName: 'Nombre del titular',
  fieldCardExpiryDate: 'Fecha de Expiración',
  placeholderCardExpiryDate: 'MM/AAAA',
  fieldCardNumber: 'Número de la Tarjeta',
  fieldOneClickCardNumber: '{brand} últimos {lastFour}',
  transactionFeeTooltip: 'Costos de Procesamiento',
  total: 'Total',
  amount: 'Amount',
  termsLabel: 'Al continuar, estarás aceptando los ',
  termsReferenceLink: 'términos y condiciones',
  termsEbanxLabel: ' de EBANX.',
  paymentPageTitle: 'Página de pagos',
  selectPaymentMethod: 'Selecciona un método de pago',
  fatalErrorTitle: 'Oops!',
  fatalErrorMessage: 'Lamentablemente, no pudimos encontrar los datos de tu pago.',
  fatalErrorFooter: 'Pago seguro con',
  panamaUsdDisclaimer: 'Los pagos son procesados por EBANX. Debido al enrutamiento regional, tu estado de cuenta bancario puede hacer referencia a Panamá (PAB), que mantiene una paridad fija de 1:1 con el USD. El cargo final debe reflejar el precio en USD mostrado.',
  merchantPaymentCode: 'Pedido #',
};

module.exports = volcanes;
